import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Terms[key][currentLang];

  const renderProhibitedItems = () => {
    const items = translations.Terms.prohibitedList[currentLang];
    return items.map((item, index) => <li key={index}>{item}</li>);
  };

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content terms-page">
          <h1>{t("title")}</h1>
          <p>{t("intro")}</p>

          <div className="highlight-box">
            {/* 1. Acceptance */}
            <h2>{t("acceptanceTitle")}</h2>
            <p>{t("acceptanceText")}</p>

            {/* Electronic contract */}
            <h2>{t("contractTitle")}</h2>
            <p>{t("contractText")}</p>

            {/* 2. User Conduct */}
            <h2>{t("userConductTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("conduct1")}</li>
              <li>{t("conduct2")}</li>
              <li>{t("conduct3")}</li>
            </ul>

            {/* Marketplace role */}
            <h2>{t("marketplaceTitle")}</h2>
            <p>{t("marketplaceText")}</p>

            {/* Fees & taxes */}
            <h2>{t("feesTitle")}</h2>
            <p>{t("feesText")}</p>

            {/* Payments, shipping, disputes */}
            <h2>{t("paymentsTitle")}</h2>
            <p>{t("paymentsText")}</p>

            {/* Listings & prohibited */}
            <h2>{t("listingsTitle")}</h2>
            <p>{t("listingsText")}</p>
            <h3>⛔ {t("prohibitedTitle")}</h3>
            <ul className="styled-bullets">
              {renderProhibitedItems()}
            </ul>

            {/* Account responsibility */}
            <h2>🔐 {t("accountTitle")}</h2>
            <p>{t("accountText")}</p>

            {/* Verification badges */}
            <h2>{t("badgesTitle")}</h2>
            <p>{t("badgesText")}</p>

            {/* User content */}
            <h2>🖼️ {t("contentOwnershipTitle")}</h2>
            <p>{t("contentOwnershipText")}</p>

            {/* IP & takedown */}
            <h2>© {t("ipTitle")}</h2>
            <p>{t("ipText")}</p>

            {/* Limitation of liability (general) */}
            <h2>{t("liabilityTitle")}</h2>
            <p>{t("liabilityText")}</p>

            {/* Liability cap */}
            <h2>{t("liabilityCapTitle")}</h2>
            <p>{t("liabilityCapText")}</p>

            {/* No warranties */}
            <h2>{t("warrantyTitle")}</h2>
            <p>{t("warrantyText")}</p>

            {/* Indemnity */}
            <h2>{t("indemnityTitle")}</h2>
            <p>{t("indemnityText")}</p>

            {/* Termination */}
            <h2>⚠️ {t("terminationTitle")}</h2>
            <p>{t("terminationText")}</p>

            {/* Service changes */}
            <h2>{t("serviceChangesTitle")}</h2>
            <p>{t("serviceChangesText")}</p>

            {/* Governing law & disputes */}
            <h2>⚖️ {t("governingLawTitle")}</h2>
            <p>{t("governingLawText")}</p>

            <h2>{t("disputeTitle")}</h2>
            <p>{t("disputeText")}</p>

            {/* Third-party links */}
            <h2>{t("thirdPartyTitle")}</h2>
            <p>{t("thirdPartyText")}</p>

            {/* Availability */}
            <h2>{t("availabilityTitle")}</h2>
            <p>{t("availabilityText")}</p>

            {/* Contact & effective date */}
            <h2>{t("contactTitle")}</h2>
            <p>{t("contactText")}</p>

            <h2>{t("effectiveTitle")}</h2>
            <p>{t("effectiveText").replace("{{date}}", "2025-10-12")}</p>

            {/* Updates to terms */}
            <h2>{t("updatesTitle")}</h2>
            <p>{t("updatesText")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
